var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Grid component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconGrid extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.41526 2.60516C2.96749 2.60516 2.60449 2.96816 2.60449 3.41593V8.09824C2.60449 8.54602 2.96749 8.90901 3.41526 8.90901H8.09757C8.54534 8.90901 8.90834 8.54602 8.90834 8.09824V3.41593C8.90834 2.96816 8.54534 2.60516 8.09757 2.60516H3.41526ZM1.10449 3.41593C1.10449 2.13973 2.13906 1.10516 3.41526 1.10516H8.09757C9.37377 1.10516 10.4083 2.13973 10.4083 3.41593V8.09824C10.4083 9.37444 9.37377 10.409 8.09757 10.409H3.41526C2.13906 10.409 1.10449 9.37444 1.10449 8.09824V3.41593Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9016 2.60516C15.4538 2.60516 15.0908 2.96816 15.0908 3.41593V8.09824C15.0908 8.54602 15.4538 8.90901 15.9016 8.90901H20.5839C21.0317 8.90901 21.3947 8.54602 21.3947 8.09824V3.41593C21.3947 2.96816 21.0317 2.60516 20.5839 2.60516H15.9016ZM13.5908 3.41593C13.5908 2.13973 14.6254 1.10516 15.9016 1.10516H20.5839C21.8601 1.10516 22.8947 2.13973 22.8947 3.41593V8.09824C22.8947 9.37444 21.8601 10.409 20.5839 10.409H15.9016C14.6254 10.409 13.5908 9.37444 13.5908 8.09824V3.41593Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.41526 15.0914C2.96749 15.0914 2.60449 15.4544 2.60449 15.9021V20.5844C2.60449 21.0322 2.96749 21.3952 3.41526 21.3952H8.09757C8.54534 21.3952 8.90834 21.0322 8.90834 20.5844V15.9021C8.90834 15.4544 8.54534 15.0914 8.09757 15.0914H3.41526ZM1.10449 15.9021C1.10449 14.6259 2.13906 13.5914 3.41526 13.5914H8.09757C9.37377 13.5914 10.4083 14.6259 10.4083 15.9021V20.5844C10.4083 21.8606 9.37377 22.8952 8.09757 22.8952H3.41526C2.13906 22.8952 1.10449 21.8606 1.10449 20.5844V15.9021Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9016 15.0914C15.4538 15.0914 15.0908 15.4544 15.0908 15.9021V20.5844C15.0908 21.0322 15.4538 21.3952 15.9016 21.3952H20.5839C21.0317 21.3952 21.3947 21.0322 21.3947 20.5844V15.9021C21.3947 15.4544 21.0317 15.0914 20.5839 15.0914H15.9016ZM13.5908 15.9021C13.5908 14.6259 14.6254 13.5914 15.9016 13.5914H20.5839C21.8601 13.5914 22.8947 14.6259 22.8947 15.9021V20.5844C22.8947 21.8606 21.8601 22.8952 20.5839 22.8952H15.9016C14.6254 22.8952 13.5908 21.8606 13.5908 20.5844V15.9021Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconGrid.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconGrid.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconGrid.prototype, "size", void 0);
if (customElements.get('cat-icon-grid') === undefined) {
    customElements.define('cat-icon-grid', BlocksIconGrid);
}
